import React, { useState, useEffect, useCallback, useMemo } from 'react'

import { IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close"
import { Dialog, Button } from '@mui/material'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import SelectInput from '../components/SelectInput';
import LabelInput from '../components/LabelInput'

import { isNumber } from '../../../utils/utils'
import { mapFlagName, ocrFlags, livenessFlags } from '../rules_utils';


function RuleCreationDialog(props) {
    const { open, setOpen, handleToast, submitRule, submitType, editingRule } = props

    const [parameters, setParameters] = useState({})
    const [parametersErrors, setParametersErrors] = useState({
        'limiter': false
    })

    const ruleOptions = useMemo(
        () => [
            {
                value: 'bureau_fraud_occurrences',
                name: 'Consulta de fraudes em Bureau',
                description: 'Caso o assinante tenha fraudes encontradas em Bureau',
                type: 'boolean'
            },
            {
                value: 'fraud_face_matches',
                name: 'Banco de fraudes',
                description: 'Caso o assinante tenha face encontrada no banco de fraudes.',
                type: 'boolean'
            },
            {
                value: 'liveness',
                name: 'Liveness',
                description: 'Assinante foi identificado como fraudador na etapa de liveness',
                type: 'boolean'
            },
            {
                value: 'brazil_geolocation',
                name: 'Assinatura fora do Brasil',
                description: 'Caso o assinante tenha feito a assinatura fora do Brasil.',
                type: 'boolean'
            },
            {
                value: 'device_key_blocklist',
                name: 'Lista de dispositivos bloqueados',
                description: 'Caso dispositivo consta na Lista de dispositivos bloqueados.',
                type: 'boolean'
            },
            {    
                value: 'same_ip_different_document_numbers',
                name: 'Mesmo IP, diferentes CPFs',
                description: 'Se existirem outros processos de assinaturas no mesmo IP para número de documentos diferentes nos últimos 30 dias.',
                type: 'boolean'
            },
            {
                value: 'facematch_document',
                name: 'Face Match de Documento',
                description: 'Pontuação de checagem de simlaridade de face com documento - OCR.',
                type: 'numeric'
            },
            {
                value: 'face_validation',
                name: 'Validação de Faces',
                description: 'Pontuação de validação se a foto do rosto confere com o CPF informado.',
                type: 'numeric'
            },
            {
                value: 'liveness_flags',
                name: 'Liveness - Indicadores',
                description: 'Lista de indicadores detectados durante a etapa de liveness.',
                type: 'list_presence'
            },
            {
                value: 'ocr_flags',
                name: 'OCR - Indicadores',
                description: 'Lista de indicadores detectados durante a etapa de OCR.',
                type: 'list_presence'
            }
        ], [])

    const [ruleOption, setRuleOption] = useState({
        value: 'fraud_face_matches',
        name: 'Banco de fraudes',
        description: 'Caso o assinante tenha face encontrada no banco de fraudes.',
        type: 'boolean'
    })

    const repprovementDecisions = useMemo(
        () => [
            {
                value: 'reproved',
                name: 'Reprovar'
            },
            {
                value: 'in_manual_analysis',
                name: 'Análise manual'
            }
        ], []
    )

    const ocrFlagsOptions = useMemo(
        () => ocrFlags, []
    )

    const livenessFlagsOptions = useMemo(
        () => livenessFlags, []
    )

    const [repprovementDecision, setRepprovementDecision] = useState({
        value: 'reproved',
        name: 'Reprovar'
    })

    const [flagOption, setFlagOption] = useState({})
    const [selectedFlags, setSelectedFlags] = useState([])

    const handleRuleInputChange = useCallback(
        (field, value) => {
            setParameters((prev) => ({
                ...prev,
                [field]: value
            }))
        },
        []
    )

    const handleBlur = (id, value) => {
        const error = validateInput[id](value);
        setParametersErrors((prev) => ({
            ...prev,
            [id]: error
        }))
    }

    const validateInput = {
        limiter: (value) => {
            return value === "" || !isNumber(value) || (Number(value) >= 100) || (Number(value) < 1)
        }
    }

    const handleRuleOptionChange = useCallback(
        (value) => {
            let rule = ruleOptions.find(opt => opt.value === value)
            if (rule) {
                setRuleOption(rule)
                setSelectedFlags([])
                return rule
            } else {
                return
            }
        }, [ruleOptions]
    )

    const handleRepprovementDecisionChange = useCallback(
        (value) => {
            setRepprovementDecision(repprovementDecisions.find(opt => opt.value === value))
        }, [repprovementDecisions]
    )

    const removeFlagItem = (value) => {
        setSelectedFlags((prev) => (prev.filter((item) => item.value !== value)))
    }

    const handleFlagOptionChange = useCallback(
        (value, list) => {
            if (list === 'ocr_flags') {
                if (selectedFlags.length > 0) {
                    if (selectedFlags.find(selectedFlag => selectedFlag.value === value)) {
                        setFlagOption({})
                        return
                    } else {
                        setSelectedFlags((prev) => ([...prev, ocrFlagsOptions.find(opt => opt.value === value)]))
                    }
                } else {
                    setSelectedFlags((prev) => ([...prev, ocrFlagsOptions.find(opt => opt.value === value)]))
                }
            } else if (list === 'liveness_flags') {
                if (selectedFlags.length > 0) {
                    if (selectedFlags.find(selectedFlag => selectedFlag.value === value)) {
                        setFlagOption({})
                        return
                    } else {
                        setSelectedFlags((prev) => ([...prev, livenessFlagsOptions.find(opt => opt.value === value)]))
                    }
                } else {
                    setSelectedFlags((prev) => ([...prev, livenessFlagsOptions.find(opt => opt.value === value)]))
                }
            }
            setFlagOption({})
        }, [ocrFlagsOptions, livenessFlagsOptions, selectedFlags]
    )

    const handleAvailableFlagOptions = (list) => {
        if (list === 'ocr_flags') {
            return ocrFlagsOptions
        } else if (list === 'liveness_flags') {
            return livenessFlagsOptions
        }

        return [];
    };
    const mapRule = () => {
        const rule = {
            step: '',
            type: '',
            parameters: [

            ]
        }

        rule.step = ruleOption.value
        rule.type = ruleOption.type

        switch (rule.type) {
            case 'boolean':
                if ([
                    'fraud_face_matches',
                    'liveness',
                    'brazil_geolocation',
                    'same_ip_different_document_numbers',
                    'device_key_blocklist',
                    'bureau_fraud_occurrences'
                ].includes(rule.step)) {
                    rule.parameters.push(
                        {
                            decision: repprovementDecision.value
                        }
                    )
                } else {
                    return
                }
                break
            case 'numeric':
                if ([
                    'facematch_document', 
                    'face_validation'
                ].includes(rule.step)) {
                    rule.parameters.push(
                        {
                            comparison_type: "less_or_equal",
                            decision: repprovementDecision.value,
                            value: parameters.limiter
                        }
                    )
                } else {
                    return
                }
                break
            case 'list_presence':
                if ([
                    'ocr_flags',
                    'liveness_flags'
                ].includes(rule.step)) {
                    rule.parameters.push(
                        {
                            decision: repprovementDecision.value,
                            value: selectedFlags.map(flag => flag.value)
                        }
                    )
                } else {
                    return
                }
                break
            default:
                return
        }

        return rule
    }

    const resetForm = useCallback(
        () => {
            setParametersErrors({
                'limiter': false
            })
            setRepprovementDecision({
                value: 'reproved',
                name: 'Reprovar'
            })
            switch (ruleOption.value) {
                case 'facematch_document':
                    setParameters((prev) => {
                        const new_value = {
                            ...prev,
                            'limiter': '80'
                        }
                        return new_value
                    })
                    break
                case 'face_validation':
                    setParameters((prev) => {
                        const new_value = {
                            ...prev,
                            'limiter': '80'
                        }
                        return new_value
                    })
                    break
                case 'ocr_flags':
                    setSelectedFlags([])
                    break
                case 'liveness_flags':
                    setSelectedFlags([])
                    break
                default:
                    break
            }
        },
        [ruleOption, setParametersErrors]
    )
    useEffect(() => {
        if (!editingRule) {
            resetForm()
        }
    }, [ruleOption, editingRule, resetForm])


    useEffect(() => {
        if (editingRule) {
            let newRuleOption = handleRuleOptionChange(editingRule.step)

            let key = ''
            let value = null
            let decision = 'reproved'

            if (newRuleOption.type === 'numeric') {
                value = editingRule.parameters[0].value
                key = 'limiter'
                handleRuleInputChange(key, value)
            } else if (newRuleOption.type === 'list_presence') {
                value = editingRule.parameters[0].value
                setSelectedFlags(value.map((flag) => ({ value: flag, name: mapFlagName(flag) })))
            }

            decision = editingRule.parameters[0].decision
            handleRepprovementDecisionChange(decision)
        }
    }, [editingRule, handleRepprovementDecisionChange, handleRuleInputChange, handleRuleOptionChange])

    return (
        <>
            <Dialog
                open={open}
                slotProps={{
                    backdrop: {
                        style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' }
                    }
                }}
            >
                <div style={{ width: '400px', padding: '2rem' }}>
                    <IconButton
                        aria-label="Close"
                        onClick={() => {
                            setOpen(false)
                            resetForm()
                        }}
                        style={{ float: "right" }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <h1 style={{ marginBottom: '2rem' }}>Criação de regra</h1>
                    <div>
                        <h2 style={{ marginBottom: '10px' }}>Selecione qual regra deseja adicionar:</h2>
                        <SelectInput
                            optionSelected={ruleOption}
                            items={ruleOptions}
                            valueKey="value"
                            labelKey="name"
                            onValueChange={handleRuleOptionChange}
                        />
                    </div>
                    <div style={{ marginBottom: '20px', marginTop: '10px' }}>
                        <p style={{ marginBottom: '5px', fontSize: '12px' }}><span><b>Descrição</b></span></p>
                        <p style={{ marginBottom: '5px', fontSize: '12px' }}>{ruleOption.description}</p>
                    </div>

                    {
                        ruleOption.type === 'boolean' &&
                        <>
                            <div>
                                <h2 style={{ marginBottom: '10px' }}>Decisão final:</h2>
                                <SelectInput
                                    optionSelected={repprovementDecision}
                                    items={repprovementDecisions}
                                    valueKey="value"
                                    labelKey="name"
                                    onValueChange={handleRepprovementDecisionChange}
                                />
                            </div>
                        </>
                    }

                    {
                        ruleOption.type === 'numeric' &&
                        <>
                            <div>
                                <div>
                                    <LabelInput
                                        labelValue="Limitador"
                                        value={parameters.limiter || ''}
                                        onChange={(value) => { handleRuleInputChange('limiter', value) }}
                                        onBlur={(value) => handleBlur("limiter", value)}
                                        error={parametersErrors['limiter']}
                                        errorMessage={parametersErrors['limiter'] ? 'Adicione um número válido entre 1 e 99' : ''}
                                    />
                                </div>
                                <div>
                                    <h2 style={{ marginBottom: '10px' }}>Decisão final:</h2>
                                    <SelectInput
                                        optionSelected={repprovementDecision}
                                        items={repprovementDecisions}
                                        valueKey="value"
                                        labelKey="name"
                                        onValueChange={handleRepprovementDecisionChange}
                                    />
                                </div>
                            </div>

                            <div style={{ marginBottom: '10px', marginTop: '30px' }}>
                                <h2 style={{ marginBottom: '10px' }}>Resumo:</h2>

                                <p style={{ marginBottom: '5px', fontSize: '12px' }}>
                                    <span><b>{repprovementDecision.name}</b>, se pontuação menor ou igual a <b>{parameters.limiter}</b></span>
                                </p>
                            </div>
                        </>

                    }

                    {
                        ruleOption.type === 'list_presence' &&
                        <>
                            <div>
                                <div>
                                    <h2 style={{ marginBottom: '10px' }}>Indicadores:</h2>
                                    <SelectInput
                                        optionSelected={flagOption}
                                        items={handleAvailableFlagOptions(ruleOption.value)}
                                        valueKey="value"
                                        labelKey="name"
                                        onValueChange={(value) => handleFlagOptionChange(value, ruleOption.value)}
                                    />
                                </div>
                                <div>
                                    <h2 style={{ marginBottom: '10px' }}>Decisão final:</h2>
                                    <SelectInput
                                        optionSelected={repprovementDecision}
                                        items={repprovementDecisions}
                                        valueKey="value"
                                        labelKey="name"
                                        onValueChange={handleRepprovementDecisionChange}
                                    />
                                </div>
                            </div>

                            <div style={{ marginBottom: '10px', marginTop: '30px' }}>
                                <h2 style={{ marginBottom: '10px' }}>Resumo:</h2>

                                <p style={{ marginBottom: '5px', fontSize: '12px' }}>
                                    <span><b>{repprovementDecision.name}</b>, se os indicadores abaixo forem detectados:</span>
                                    <ul style={{ marginTop: '15px' }}>
                                        {
                                            selectedFlags.map((flag) => (
                                                <li key={flag.value} style={{ marginLeft: '30px', marginTop: '5px' }}>
                                                    <div style={{ width: '100%', padding: '5px', display: 'flex', justifyContent: 'space-between' }}>
                                                        <span className="data-field__value">
                                                            {mapFlagName(flag.value)}
                                                        </span>
                                                        <IconButton
                                                            aria-label="Close"
                                                            onClick={() => removeFlagItem(flag.value)}
                                                            style={{ float: "right", height: '15px' }}
                                                        >
                                                            <RemoveCircleOutlineIcon style={{ color: 'red' }} />
                                                        </IconButton>
                                                    </div>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </p>
                            </div>
                        </>
                    }

                    <div style={{ alignItems: 'center', textAlign: 'center' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                if (Object.values(parametersErrors).find(error => error)) {
                                    handleToast('Existem campos mal preenchidos', 'warning')
                                } else if (ruleOption.type === 'list_presence' && selectedFlags.length === 0) {
                                    handleToast('É necessário selecionar pelo menos um indicador', 'warning')

                                } else {
                                    let rule = mapRule()
                                    submitRule(rule, submitType)
                                }
                            }}
                            style={{ width: '100%', margin: '2rem 0', backgroundColor: 'primaryColor' }}
                        >
                            {submitType === 'add' ? 'Adicionar' : 'Editar'}
                        </Button>
                    </div>
                </div>
            </Dialog>
        </>
    )
};

export default RuleCreationDialog;